export default "__VITE_ASSET__B5G7UzEB__"